import React from 'react'
import upgradePackages from './UpgradePackage';
import { postMessageToRuntime } from '../../Helpers/Runtime/runtime';
import { useTranslation } from 'react-i18next';

// TODO: Add translations for the following UpgradeContent component
const UpgardeContent = (props) => {
    const {
        showInline,
        showBackButton,
        onBack,
        toggleDialog,
        Type,
        Headline,
        organization,
        isShowFromWorkspace
    } = props

    const { t } = useTranslation(
        "upgrade"
    )

    const redirectToUpgradeSubscription = (event) => {
        event.preventDefault()
        sendOpenPopupMessageToRuntime();
        toggleDialog();
    }

    function sendOpenPopupMessageToRuntime() {
        postMessageToRuntime({
            eventType: "OPEN_PRICING_POPUP"
        })
    }

    const upgradePackage = upgradePackages[Type];

    return (

        // <form className={showInline ? "p-3 feature":"px-3 feature"}>
        //     <div className="row">
        //         <div className="col-xl-1 col-lg-1 col-md-1">
        //         </div>
        //         <div className="col-xl-3 col-lg-3 col-md-3">
        //             <img src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/NoSubscription.png`} alt="responsive webite" class="img-fluid" />
        //         </div>
        //         <div className="col-xl-5 col-lg-5 col-md-5 mt-5 lh-25 hdr">
        //             <div className="ps-3" dangerouslySetInnerHTML={{ __html: Headline }}></div>
        //         </div>
        //     </div>
        //     {/* <div className="row pt-4">
        //          <div className="col-xl-12 col-lg-12 col-md-12">
        //             <h5 className="text-muted">
        //                 {upgradePackage.Description}--
        //             </h5>
        //         </div> 
        //     </div> */}
        //     <div className="row pt-4">
        //         <div className="col-xl-12 col-lg-12 col-md-12">
        //             <h5 className="text-muted">
        //                 {upgradePackage.FeatureHeader}
        //             </h5>
        //         </div>
        //     </div>
        //     <div className="row justify-content-start pt-3">
        //         <div className="col-xl-6 col-lg-6 col-md-6">
        //             <h6>
        //                 <i class="fa fa-check text-primary me-3" aria-hidden="true"></i>{upgradePackage.Feature1}
        //             </h6>
        //         </div>
        //         <div className="col-xl-6 col-lg-6 col-md-6">
        //             <h6>
        //                 <i class="fa fa-check text-primary me-3" aria-hidden="true"></i>{upgradePackage.Feature2}
        //             </h6>
        //         </div>
        //     </div>
        //     <div className="row justify-content-start">
        //         <div className="col-xl-6 col-lg-6 col-md-6">
        //             <h6>
        //                 <i class="fa fa-check text-primary me-3" aria-hidden="true"></i>{upgradePackage.Feature3}
        //             </h6>
        //         </div>
        //         <div className="col-xl-6 col-lg-6 col-md-6">
        //             <h6>
        //                 <i class="fa fa-check text-primary me-3" aria-hidden="true"></i>{upgradePackage.Feature4}
        //             </h6>
        //         </div>
        //     </div>
        //     <div className="row justify-content-start">
        //         <div className="col-xl-6 col-lg-6 col-md-6">
        //             <h6>
        //                 <i class="fa fa-check text-primary me-3" aria-hidden="true"></i>{upgradePackage.Feature5}
        //             </h6>
        //         </div>
        //         <div className="col-xl-6 col-lg-6 col-md-6">
        //             <h6>
        //                 <i class="fa fa-check text-primary me-3" aria-hidden="true"></i>{upgradePackage.Feature6}
        //             </h6>
        //         </div>
        //     </div>
        //     <div className={showInline ? "text-start mt-4" : "text-end mt-4"}>
        //         {
        //             showBackButton &&
        //             <button onClick={onBack} className='btn btn-secondary me-2'>
        //                 Back to App Library
        //             </button>
        //         }
        //         <button onClick={redirectToUpgradeSubscription} className='btn btn-upgrade'>
        //             Upgrade Plan
        //         </button>
        //     </div>
        // </form>

        <form className={showInline ? "p-3 feature" : "px-3 feature"}>
            <div className={isShowFromWorkspace ? "text-webkit" : ""}>
                <div className={isShowFromWorkspace ? "w-75" : ""}>
                    <div className="row text-center">
                        <div className="col-xl-1 col-lg-1 col-md-1">
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12 ">
                            <img src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/AliceBlue.jpg`} alt="responsive webite" class="img-fluid" />
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12 mt-3 lh-25 hdr">
                            <div className="ps-3" >
                                {t("it_time_to_upgrade")}
                            </div>
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12 mt-2 opacity-50">
                            {t("congratulations_on_the_success_of_your_app")}
                            <p>
                                {t("it_seems_you_have_reached_the_full_potential_of_your_current_plan")}
                            </p>
                            {t("to_continue_expanding_your_capabilities_and_accommodate_larger_apps")}
                            <br />
                            {t("as_well_as_invite_more_users_we_recommend_upgrading_to_a_higher_plan")}
                        </div>
                    </div>
                    <div className="text-center mt-5">
                        {
                            showBackButton &&
                            <button onClick={onBack} className='btn btn-secondary me-2'>
                                {t("buttons.back_to_app_library")}
                            </button>
                        }
                        <button onClick={redirectToUpgradeSubscription} className='btn btn-upgrade'>
                            {t("buttons.upgrade_plan")}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default UpgardeContent
